import { Store } from "pullstate";

export const UIStore = new Store({
  theme: {
    isDarkMode: false
  },
  user: 'James Bond'
});